import React from "react";
import PropTypes from "prop-types";
import {FaSolidIcon} from "../../../components/FontAwesomeIcons";

export class UserEventStatisticCard extends React.Component {
    constructor(props) {
        super(props);
        this.iconStyle = {
            width: "36px",
            minWidth: "36px",
            height: "36px",
        };
    }

    getIconStyle = _ => ({
        ...this.iconStyle,
        color: this.props.color || "#293069",
        backgroundColor: this.props.backgroundColor || "#f8f9fa",
    })

    render() {
        return (
            <div className={"col-6 mb-2 px-1"}>
                <div className={"bg-white shadow-sm rounded p-2 h-100"}>
                    <div className={"d-flex align-items-center"}>
                        <div className={"rounded d-flex align-items-center justify-content-center mr-2"} style={this.getIconStyle()}>
                            <FaSolidIcon name={this.props.icon}/>
                        </div>
                        <div className={"flex-grow-1 overflow-hidden"}>
                            <div className={"small text-muted text-truncate"}>{this.props.title}</div>
                            <div className={"font-weight-bold text-truncate"}>{this.props.value}</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

UserEventStatisticCard.propTypes = {
    title: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    icon: PropTypes.string,
    color: PropTypes.string,
    backgroundColor: PropTypes.string,
};
